import { render } from "./WritingBoard.vue?vue&type=template&id=1bd2a007&scoped=true&ts=true"
import script from "./WritingBoard.vue?vue&type=script&lang=ts"
export * from "./WritingBoard.vue?vue&type=script&lang=ts"

import "./WritingBoard.vue?vue&type=style&index=0&id=1bd2a007&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd2a007"]])

export default __exports__